//ログイン画面
import Signin from '../../views/signin/form.vue';

window.Vue.component('signin', Signin);
